export const log = (errMsg: string) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(errMsg);
  }
};
